export default {
  "buttons": {
    "loginWithTwitch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrar com Twitch"])},
    "loginWithTwitter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrar com Twitter"])}
  }
}